import React, { useState } from "react";
import Modal from "../common/Modal";
import FeedbackSent from "../layout/FeedbackSent";
import FeedbackForm from "../layout/FeedbackForm";
import PmbokSevenToc from "../layout/PmbokSevenToc";
import PmbokSixToc from "../layout/PmbokSixToc";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj } from '../../analytics/analyticsObject';
import { useHistory } from "react-router";
import { useMobile } from "../../hooks/useMobile";
import getEnvEndpoints from "../../utils/endpoints";
const SideNavigationModalLinks = (showPmbok7Link, feedbacks) => {
  const [isFeedbackModalVisible, setIsFeedbackModalVisible] = useState(false);
  const [isPmbokTocModalVisible, setIsPmbokTocModalVisible] = useState(false);
  const [isPmbok6TocModalVisible, setIsPmbok6TocModalVisible] = useState(false);
  const [isFeedbackSentModalVisible, setIsFeedbackSentModalVisible] = useState(false);
  const [feedbackPost, setFeedbackPost] = useState("");
  const [feedbackContentKey, setFeedbackContentKey] = useState("");
  const [feedbackSentContentKeys, setFeedbackSentContentKeys] = useState([]);
  const [showFeedbackAlert, setShowFeedbackAlert] = useState(false);
  const history = useHistory();
  const isMobile = useMobile();
  const showPmbok6LinkToc = false;
  const endpoints = getEnvEndpoints();
  const newTocFlag = endpoints && endpoints?.newTocEnabled === 'true' ? true : false
  const closeFeedbackModal = () => {
    setFeedbackPost("");
    setFeedbackContentKey("");
    setIsFeedbackModalVisible(false);
    setIsPmbokTocModalVisible(false);
    setIsPmbok6TocModalVisible(false);
  };
  const feedbackSent = () => {
    if (!feedbackSentContentKeys.includes(feedbackContentKey)) {
      setFeedbackSentContentKeys([
        ...feedbackSentContentKeys,
        feedbackContentKey,
      ]);
    }
    setFeedbackContentKey("");
    setIsFeedbackModalVisible(false);
    setIsFeedbackSentModalVisible(true);
    setShowFeedbackAlert(false);
  };
  const sideNavLinks = (item) => {
    adobeCustomLog(item);

  };
  const adobeCustomLog = (path) => {
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let customLObj = getAdobeAnalyticsCustomLinkObj(path, "side-nav", "/" + path);
    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      pageData: false,
      adobePushTracking: false,
    });
  }
  return (
    <>{newTocFlag ?
      <div
        className="flex w-64 mb-24 sm:mb-48 justify-center fixed bottom-0 left-0 z-50 transform -rotate-90 cursor-pointer z-30 side-nav-pmbok7"
        style={{ marginBottom: `calc(100vh - 22rem)` }}
        onClick={() => { history.push("/tableofcontent"); sideNavLinks('Table of Contents') }}
        adoberegion="side-nav"
      >
        <div className="bg-orange-brand-500 hover:bg-orange-brand-600 text-white text-base rounded-lg shadow-md px-2 py-1 sm:px-4 sm:py-2 border-purple-brand-200 border-2">
          <span className="hidden sm:inline-block mr-2 align-middle">
            Table of Contents
          </span>
          <span className="inline-block align-middle lg:rotate-90">
            <svg
              className="h-5 w-5 text-black-500"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <line x1="9" y1="6" x2="20" y2="6" />
              <line x1="9" y1="12" x2="20" y2="12" />
              <line x1="9" y1="18" x2="20" y2="18" />
              <line x1="5" y1="6" x2="5" y2="6.01" />
              <line x1="5" y1="12" x2="5" y2="12.01" />
              <line x1="5" y1="18" x2="5" y2="18.01" />
            </svg>
          </span>
        </div>
      </div> : <div></div>}
      {showPmbok7Link.showPmbok7Link && (isPmbokTocModalVisible ? (
        <Modal onClose={closeFeedbackModal} onClickOutside={true}>
          <PmbokSevenToc onClose={closeFeedbackModal} />
        </Modal>
      ) : (!newTocFlag ? (
        <div
          className="flex w-64 mb-24 sm:mb-48 justify-center fixed bottom-0 left-0 z-50 transform -rotate-90 cursor-pointer z-30 side-nav-pmbok7"
          style={{ marginBottom: `calc(100vh - 31.8rem)` }}
          onClick={() => {
            setIsPmbokTocModalVisible(true)
            sideNavLinks('PMBOK 7th Ed.')
          }
          }
        >
          <div className="bg-orange-brand-500 hover:bg-orange-brand-600 text-white text-base rounded-lg shadow-md px-2 py-1 sm:px-4 sm:py-2 border-purple-brand-200 border-2">
            <span className="hidden sm:inline-block mr-2 align-middle">PMBOK 7th Ed.</span>
            <span className="inline-block align-middle">
              <img alt="pmbok7 icon" src="/images/pmbok7-icon.svg" width="22" />
            </span>
          </div>
        </div>
      ) : <div></div>))
      }
      {(!newTocFlag || showPmbok6LinkToc) ? (isPmbok6TocModalVisible ? (
        <Modal onClose={closeFeedbackModal} onClickOutside={true}>
          <PmbokSixToc onClose={closeFeedbackModal} />
        </Modal>
      ) : (
        <div
          className="flex w-64 mb-24 sm:mb-48 justify-center fixed bottom-0 left-0 z-50 transform -rotate-90 cursor-pointer z-30 side-nav-pmbok6"
          style={{ marginBottom: `calc(100vh - 19.8rem)` }}
          onClick={() => {
            setIsPmbok6TocModalVisible(true)
            sideNavLinks('PMBOK 7th Ed.')
          }
          }
        >
          <div className="bg-gray-brand-500 hover:bg-gray-brand-600 text-white text-base rounded-lg shadow-md px-2 py-1 sm:px-4 sm:py-2 border-purple-brand-200 border-2">
            <span className="hidden sm:inline-block mr-2 align-middle">PMBOK 6th Ed.</span>
            <span className="inline-block align-middle">
              <img alt="pmbok6 icon" src="/images/pmbok6-icon.svg" width="22" />
            </span>
          </div>
        </div>
      )) : <div></div>
      }

      {isFeedbackModalVisible ? (
        <Modal onClose={closeFeedbackModal}>
          <FeedbackForm
            post={feedbackPost}
            contentKey={feedbackContentKey}
            onSubmit={() => feedbackSent()}
            feedbacks={feedbacks}
          />
        </Modal>
      ) : (
        <div
          className="flex w-60 mb-32 sm:mb-64 justify-center fixed bottom-0 right-0 z-50 transform -rotate-90 cursor-pointer sm:-mr-20 z-30 side-nav-feedback"
          style={{ marginRight: '-107px', marginBottom: `calc(60vh - 16.8rem)` }}
          onClick={() => setIsFeedbackModalVisible(true)}
        >
          {/* <div className="bg-purple-brand-500 hover:bg-purple-brand-600 text-white text-xl rounded-lg shadow-md px-2 py-1 sm:px-4 sm:py-2 border-purple-brand-200 border-2">
            <span className="hidden sm:inline-block mr-2">Feedback</span>
            <span className="inline-block">
              <i className="far fa-comment-dots" />
            </span>
          </div> */}
        </div>
      )}
      {isFeedbackSentModalVisible && (
        <Modal onClose={() => setIsFeedbackSentModalVisible(false)}>
          <FeedbackSent setModalVisible={setIsFeedbackSentModalVisible} />
        </Modal>
      )}
    </>
  );
};

export default SideNavigationModalLinks;